// Mock data for Scott Parrish Portfolio

// Using reliable placeholder images that match project categories
export const portfolioData = {
  name: "Scott Parrish",
  tagline: "Visual Designer & Creative Director",
  philosophy: "Art is the evolution of visual knowledge.",
  aboutText: "My creative journey has been profoundly shaped by a simple yet powerful phrase: 'Art is the evolution of visual knowledge.' For four years I contemplated those words, painted boldly on a classroom wall, and their influence continues to resonate deeply within my work. This statement became more than just a motto; it became a guiding principle, pushing me to explore new techniques, experiment with diverse mediums, and consistently seek a deeper understanding of the visual language I employ. My artistic process is one of continuous learning and growth, a constant striving to refine my skills and broaden my perspective. Each piece I create represents a step in this ongoing evolution, a testament to the transformative power of visual communication.",
  
  projects: [
    {
      id: 1,
      title: "Info Graphics",
      category: "Visual Communication",
      year: "2025",
      image: "/images/infographics/infographic-1.png",
      description: "Data-driven visual storytelling that transforms complex information into engaging, accessible graphics.",
      gallery: [
        "/images/infographics/infographic-1.png",
        "/images/infographics/infographic-2.png",
        "/images/infographics/infographic-3.png",
        "/images/infographics/infographic-4.png",
        "/images/infographics/infographic-5.png",
        "/images/infographics/infographic-6.png",
        "/images/infographics/infographic-7.png",
        "/images/infographics/infographic-8.png",
        "/images/infographics/infographic-9.png",
        "/images/infographics/infographic-10.png"
      ]
    },
    {
      id: 2,
      title: "Internal Campaigns",
      category: "Brand Communication",
      year: "2025",
      image: "/images/internalcampaigns/campaign-1.jpg",
      description: "Strategic internal marketing initiatives that inspire and engage teams with compelling visual narratives.",
      gallery: [
        "/images/internalcampaigns/campaign-1.jpg",
        "/images/internalcampaigns/campaign-2.jpg",
        "/images/internalcampaigns/campaign-3.jpg",
        "/images/internalcampaigns/campaign-4.jpg",
        "/images/internalcampaigns/campaign-5.jpg",
        "/images/internalcampaigns/campaign-6.jpg",
        "/images/internalcampaigns/campaign-7.jpg",
        "/images/internalcampaigns/campaign-8.jpg",
        "/images/internalcampaigns/campaign-9.jpg",
        "/images/internalcampaigns/campaign-10.jpg",
        "/images/internalcampaigns/campaign-11.jpg",
        "/images/internalcampaigns/campaign-12.jpg",
        "/images/internalcampaigns/campaign-13.png",
        "/images/internalcampaigns/campaign-14.jpg",
        "/images/internalcampaigns/campaign-15.jpg",
        "/images/internalcampaigns/campaign-16.jpg",
        "/images/internalcampaigns/campaign-17.png",
        "/images/internalcampaigns/campaign-18.png",
        "/images/internalcampaigns/campaign-19.png",
        "/images/internalcampaigns/campaign-20.png",
        "/images/internalcampaigns/campaign-21.png",
        "/images/internalcampaigns/campaign-22.png",
        "/images/internalcampaigns/campaign-23.png",
        "/images/internalcampaigns/campaign-24.png",
        "/images/internalcampaigns/campaign-25.png",
        "/images/internalcampaigns/campaign-26.png",
        "/images/internalcampaigns/campaign-27.png",
        "/images/internalcampaigns/campaign-28.png",
        "/images/internalcampaigns/campaign-29.png",
        "/images/internalcampaigns/campaign-30.png",
        "/images/internalcampaigns/campaign-31.png",
        "/images/internalcampaigns/campaign-32.png",
        "/images/internalcampaigns/campaign-33.png",
        "/images/internalcampaigns/campaign-34.jpg",
        "/images/internalcampaigns/campaign-35.jpg",
        "/images/internalcampaigns/campaign-36.jpg",
        "/images/internalcampaigns/campaign-37.jpg",
        "/images/internalcampaigns/campaign-38.jpg"
      ]
    },
    {
      id: 3,
      title: "Direct Mail",
      category: "Print Design",
      year: "2025",
      image: "/images/directmail/directmail-1.png",
      description: "Tactile, memorable direct mail pieces that cut through digital noise with bold design and messaging.",
      gallery: [
        "/images/directmail/directmail-1.png",
        "/images/directmail/directmail-2.png",
        "/images/directmail/directmail-3.png",
        "/images/directmail/directmail-4.jpg",
        "/images/directmail/directmail-5.jpg",
        "/images/directmail/directmail-6.jpg",
        "/images/directmail/directmail-7.png",
        "/images/directmail/directmail-8.jpg",
        "/images/directmail/directmail-9.jpg",
        "/images/directmail/directmail-10.jpg",
        "/images/directmail/directmail-11.jpg",
        "/images/directmail/directmail-12.jpg",
        "/images/directmail/directmail-13.jpg"
      ]
    },
    {
      id: 4,
      title: "Invitations and Awards",
      category: "Event Design",
      year: "2025",
      image: "/images/invitations/invitation-1.jpg",
      description: "Elegant invitation design and award collateral that sets the tone for memorable events and celebrations.",
      gallery: [
        "/images/invitations/invitation-1.jpg",
        "/images/invitations/invitation-2.jpg",
        "/images/invitations/invitation-3.png",
        "/images/invitations/invitation-4.png",
        "/images/invitations/invitation-5.jpg",
        "/images/invitations/invitation-6.jpg",
        "/images/invitations/invitation-7.jpg",
        "/images/invitations/invitation-8.jpg",
        "/images/invitations/invitation-9.jpg",
        "/images/invitations/invitation-10.jpg",
        "/images/invitations/invitation-11.jpg"
      ]
    },
    {
      id: 5,
      title: "Package Design",
      category: "Product Design",
      year: "2024",
      image: "/images/packagedesign/package-1.jpg",
      description: "Innovative packaging solutions that marry form and function while enhancing brand identity on shelf.",
      gallery: [
        "/images/packagedesign/package-1.jpg",
        "/images/packagedesign/package-2.jpg",
        "/images/packagedesign/package-3.jpg",
        "/images/packagedesign/package-4.jpg",
        "/images/packagedesign/package-5.jpg",
        "/images/packagedesign/package-6.jpg",
        "/images/packagedesign/package-7.jpg",
        "/images/packagedesign/package-8.jpg",
        "/images/packagedesign/package-9.jpg",
        "/images/packagedesign/package-10.png",
        "/images/packagedesign/package-11.png"
      ]
    },
    {
      id: 6,
      title: "Outdoor and Live Space",
      category: "Environmental Design",
      year: "2024",
      image: "/images/outdoor/outdoor-1.png",
      description: "Large-scale outdoor installations and environmental graphics that transform spaces into brand experiences.",
      gallery: [
        "/images/outdoor/outdoor-1.png",
        "/images/outdoor/outdoor-2.jpg",
        "/images/outdoor/outdoor-3.png",
        "/images/outdoor/outdoor-4.png",
        "/images/outdoor/outdoor-5.png",
        "/images/outdoor/outdoor-6.jpg",
        "/images/outdoor/outdoor-7.jpg",
        "/images/outdoor/outdoor-8.jpg",
        "/images/outdoor/outdoor-9.jpg",
        "/images/outdoor/outdoor-10.png"
      ]
    },
    {
      id: 7,
      title: "Event Space and Takeovers",
      category: "Experiential Design",
      year: "2024",
      image: "/images/events/event-1.png",
      description: "Immersive event spaces and brand takeovers that create unforgettable, shareable moments.",
      gallery: [
        "/images/events/event-1.png",
        "/images/events/event-2.jpg",
        "/images/events/event-3.jpg",
        "/images/events/event-4.jpg",
        "/images/events/event-5.jpg",
        "/images/events/event-6.jpg",
        "/images/events/event-7.jpg",
        "/images/events/event-8.jpg",
        "/images/events/event-9.jpg",
        "/images/events/event-10.jpg",
        "/images/events/event-11.png",
        "/images/events/event-12.png",
        "/images/events/event-13.png",
        "/images/events/event-14.png",
        "/images/events/event-15.png",
        "/images/events/event-16.jpg",
        "/images/events/event-17.jpg",
        "/images/events/event-18.jpg",
        "/images/events/event-19.jpg",
        "/images/events/event-20.jpg",
        "/images/events/event-21.jpg",
        "/images/events/event-22.jpg",
        "/images/events/event-23.png"
      ]
    },
    {
      id: 8,
      title: "Illustration and Storyboards",
      category: "Illustration",
      year: "2024",
      image: "/images/illustration/illustration-1.jpg",
      description: "Custom illustrations and detailed storyboards that bring concepts to life with precision and creativity.",
      gallery: [
        "/images/illustration/illustration-1.jpg",
        "/images/illustration/illustration-2.jpg",
        "/images/illustration/illustration-3.jpg",
        "/images/illustration/illustration-4.jpg",
        "/images/illustration/illustration-5.jpg",
        "/images/illustration/illustration-6.jpg",
        "/images/illustration/illustration-7.jpg",
        "/images/illustration/illustration-8.jpg",
        "/images/illustration/illustration-9.jpg",
        "/images/illustration/illustration-10.jpg",
        "/images/illustration/illustration-11.jpg",
        "/images/illustration/illustration-12.jpg",
        "/images/illustration/illustration-13.jpg",
        "/images/illustration/illustration-14.jpg",
        "/images/illustration/illustration-15.jpg",
        "/images/illustration/illustration-16.jpg",
        "/images/illustration/illustration-17.jpg",
        "/images/illustration/illustration-18.jpg",
        "/images/illustration/illustration-19.jpg",
        "/images/illustration/illustration-20.jpg",
        "/images/illustration/illustration-21.jpg",
        "/images/illustration/illustration-22.jpg"
      ]
    }
  ],
  
  contact: {
    email: "scottedwardparrish@gmail.com",
    phone: "248-234-1326",
    location: "Available Worldwide"
  },
  
  social: {
    linkedin: "https://www.linkedin.com/in/scott-e-parrish/",
    behance: "#",
    instagram: "#"
  }
};